import { API_URL } from "../../config";

export const uploadPDF = async (file: File | Blob): Promise<string | null> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const baseUrl = process.env.REACT_APP_API_URL;
    
    const response = await fetch(`${API_URL}/utility/pdf/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`, 
      },
    });


    if (response.ok) {
      const responseData = await response.json();
      console.log(responseData);
      return responseData.data;
    } else {
      throw new Error('Error uploading PDF');
    }
  } catch (error) {
    console.error(error);
    throw new Error('Error uploading PDF');
  }
};
